import { AddressDTO } from '@/backend/models/AddressDTO'
import { BalanceAsset, DepositWalletAddressResult, NetworkByCoin, TransactionAssets } from '../../backend/api'
import { Status } from '../../backend/types'

export type InitialState = {
  assetsForTransactions: {
    assets: TransactionAssets
    status: Status
  }
  withdrawAddresses: {
    status: Status
    addresses: AddressDTO[]
  }
  depositWalletAddress: {
    address: DepositWalletAddressResult | null
    status: Status
  }
  transactionSendResult: Record<string, { status: Status; date?: string }>
  assetsForWithdrawAndDeposit: AssetsForWithdrawAndDeposit
  transferData: any[]
  coinBalance: {
    balanceAssets: BalanceAsset[]
    status: Status
  }
  withdrawAssetResult: { status: Status; date?: string }
  historyConvert: {
    isLoading: boolean
    list: TradeFlowItemType[]
    moreData: boolean
    filters: {
      startTime: string
      endTime: string
      limit: number
      coin: string | null
    }
  }
  exchangeHistory: {
    history: ExchangeHistoryItemInterface[]
    historyStatus: Status
    historyCurrentLast: string // cursor or page
    historyReachedEnd: boolean
    bybitNextCursor: string
    startDate: string
    endDate: string
    startTime: string
    endTime: string
    incomeType: string
    coin: string
    exchangeTigerXType: string
  }
}

export type ExchangeHistoryItemInterface = Record<string, string | number>

export type AssetInfo = {
  coin: string
  networks: NetworkByCoin[]
}

type CoinName = string

export type AssetsForWithdrawAndDeposit = { assets: Record<CoinName, AssetInfo['networks']>; assetsStatus: Status }
export type SelectHistoryTransactionOptions<T extends string> = {
  label: string
  value: T
}

export type TradeFlowItemType = {
  createTime: number // Время создания (в миллисекундах)
  orderId: number // Уникальный идентификатор ордера
  fromAsset: string // Валюта, из которой конвертируется
  toAsset: string // Валюта, в которую конвертируется
  fromAmount: string // Сумма, которая конвертируется
  toAmount: string // Сумма, полученная после конвертации
  orderStatus: string // Статус ордера
}

export enum E_BybitTransactionTypes {
  TRANSFER_IN = 'TRANSFER_IN',
  TRANSFER_OUT = 'TRANSFER_OUT',
  TRADE = 'TRADE',
  SETTLEMENT = 'SETTLEMENT',
  AUTO_SOLD_COLLATERAL_INS_LOAN = 'AUTO_SOLD_COLLATERAL_INS_LOAN',
  INTEREST_REPAYMENT_INS_LOAN = 'INTEREST_REPAYMENT_INS_LOAN',
  DELIVERY = 'DELIVERY',
  LIQUIDATION = 'LIQUIDATION',
  AIRDROP = 'AIRDROP',
  BONUS = 'BONUS',
  BONUS_RECOLLECT = 'BONUS_RECOLLECT',
  FEE_REFUND = 'FEE_REFUND',
  CURRENCY_BUY = 'CURRENCY_BUY',
  CURRENCY_SELL = 'CURRENCY_SELL',
  INTEREST = 'INTEREST',
  PRINCIPLE_REPAYMENT_INS_LOAN = 'PRINCIPLE_REPAYMENT_INS_LOAN',
  BORROWED_AMOUNT_INS_LOAN = 'BORROWED_AMOUNT_INS_LOAN',
  AUTO_BUY_LIABILITY_INS_LOAN = 'AUTO_BUY_LIABILITY_INS_LOAN',
  AUTO_PRINCIPLE_REPAYMENT_INS_LOAN = 'AUTO_PRINCIPLE_REPAYMENT_INS_LOAN',
  AUTO_INTEREST_REPAYMENT_INS_LOAN = 'AUTO_INTEREST_REPAYMENT_INS_LOAN',
  TRANSFER_IN_INS_LOAN = 'TRANSFER_IN_INS_LOAN',
  TRANSFER_OUT_INS_LOAN = 'TRANSFER_OUT_INS_LOAN',
  SPOT_REPAYMENT_SELL = 'SPOT_REPAYMENT_SELL',
  SPOT_REPAYMENT_BUY = 'SPOT_REPAYMENT_BUY',
  TOKENS_SUBSCRIPTION = 'TOKENS_SUBSCRIPTION',
  TOKENS_REDEMPTION = 'TOKENS_REDEMPTION',
  AUTO_DEDUCTION = 'AUTO_DEDUCTION',
  FLEXIBLE_STAKING_SUBSCRIPTION = 'FLEXIBLE_STAKING_SUBSCRIPTION',
  FLEXIBLE_STAKING_REDEMPTION = 'FLEXIBLE_STAKING_REDEMPTION',
  FIXED_STAKING_SUBSCRIPTION = 'FIXED_STAKING_SUBSCRIPTION',
  PREMARKET_TRANSFER_OUT = 'PREMARKET_TRANSFER_OUT',
  PREMARKET_DELIVERY_SELL_NEW_COIN = 'PREMARKET_DELIVERY_SELL_NEW_COIN',
  PREMARKET_DELIVERY_BUY_NEW_COIN = 'PREMARKET_DELIVERY_BUY_NEW_COIN',
  PREMARKET_DELIVERY_PLEDGE_PAY_SELLER = 'PREMARKET_DELIVERY_PLEDGE_PAY_SELLER',
  PREMARKET_DELIVERY_PLEDGE_BACK = 'PREMARKET_DELIVERY_PLEDGE_BACK',
  PREMARKET_ROLLBACK_PLEDGE_BACK = 'PREMARKET_ROLLBACK_PLEDGE_BACK',
  PREMARKET_ROLLBACK_PLEDGE_PENALTY_TO_BUYER = 'PREMARKET_ROLLBACK_PLEDGE_PENALTY_TO_BUYER',
}

export enum E_BinanceTransactionType {
  TRANSFER = 'TRANSFER',
  WELCOME_BONUS = 'WELCOME_BONUS',
  REALIZED_PNL = 'REALIZED_PNL',
  FUNDING_FEE = 'FUNDING_FEE',
  COMMISSION = 'COMMISSION',
  INSURANCE_CLEAR = 'INSURANCE_CLEAR',
}

export enum E_OkxTransactionType {
  TRANSFER = '1',
  TRADE = '2',
  DELIVERY = '3',
  AUTO_TOKEN_CONVERSION = '4',
  LIQUIDATION = '5',
  MARGIN_TRANSFER = '6',
  INTEREST_DEDUCTION = '7',
  FUNDING_FEE = '8',
  ADL = '9',
  CLAWBACK = '10',
  SYSTEM_TOKEN_CONVERSION = '11',
  STRATEGY_TRANSFER = '12',
  DDH = '13',
  BLOCK_TRADE = '14',
  QUICK_MARGIN = '15',
  REPAY = '22',
  SPREAD_TRADING = '24',
  STRUCTURED_PRODUCTS = '26',
  COPY_TRADER_PROFIT_SHARING_EXPENSES = '250',
  COPY_TRADER_PROFIT_SHARING_REFUND = '251',
}
